var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-wrap items-center pb-10 membership-layout-container",style:([_vm.customCss])},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"mr-2",on:{"click":function($event){_vm.isNotLast(index, _vm.list.length)
        ? !_vm.isPreview && item.is_default!==2
          ? _vm.activateElement({ e: '', el: item })
          : _vm.sendToPath({ 
              name: item.is_default==2?'home':'post', params:item.is_default==2?{}: { id: item.slug } 
              })
        : () => {}}}},[_c('div',{staticClass:"space-x-2 breadcrum-text-color"},[_c('span',{class:[
          'text-sm',
          _vm.isNotLast(index, _vm.list.length) ? 'cursor-pointer' : 'active',
        ]},[_vm._v(_vm._s(item.is_default==1?_vm.courseSettings.title:item.name))]),(_vm.isNotLast(index, _vm.list.length))?_c('span',[_c('i',{staticClass:"fas fa-chevron-right text-sm arrow-grey breadcrum-text-color"})]):_vm._e()])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }